/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Grid, Paper, Button } from '@material-ui/core';
import TB from '../controls/form/TB';
import Comm from '../comm/comm';
import SelectedObjects from '../controls/SelectedObjects';
import IPGrid from '../controls/grid/IPGrid';
import ProtocolHeader from '../controls/grid/ProtocolHeader';
import ProtocolRow from '../controls/grid/ProtocolRow';

const ProtocolSearch = (props) => {
    let [dossier, setDossier] = useState(0);
    let [ss, setss] = useState("");
    let [ekatteId, ] = useState("0");
    let [showObject, setShowObject] = useState(null);
    let [title, setTitle] = useState("");
    let [searchParams, setSearchParams] = useState({
        func: "/backend/sis/secure/minutes/top/active/10",
        export: {
            xlsx: "/backend/sis/secure/minutes/search/xlsx"
        },
        params: {}
    });
    let [refresh, setRefresh] = useState(new Date());

    const Search = () => {
        setSearchParams({
            func: "/backend/sis/secure/minutes/search",
            export: {
                xlsx: "/backend/sis/secure/minutes/search/xlsx"
            },
            params: {
                "ekatteId": ekatteId === "0" ? null : ekatteId,
                "artifactReference": dossier == "0" ? null : dossier,
                "ss": ss === "" ? null : ss,
                "title": title === "" ? null : title
            }
        })

    };

    const Delete = (id) => {
        Comm.Instance().delete("backend/sis/secure/minutes?reference=" + id).then(r => {
            setRefresh(new Date());

        });
    }

    if (showObject) {
        return (<Redirect to={"Protocol/" + (showObject === -1 ? "" : showObject)} />);
    }

    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Търсене на протоколи</h2>
            <Paper>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <TB label="Име" value={title} change={setTitle} />
                    </Grid>
                    <Grid item xs={3}>
                        <SelectedObjects label="Досие" value={dossier} setValue={setDossier} objectType="dossiers" />
                    </Grid>
                    <Grid item xs={6}>
                        <TB label='В "Основни данни"' value={ss} change={setss} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={2}>
                        <Button variant="contained" color="primary" onClick={() => Search()}>
                            Търсене
                        </Button>
                    </Grid>
                    <Grid item xs={8}>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" color="secondary" onClick={() => setShowObject(-1)}>
                            Нов протокол
                        </Button>
                    </Grid>
                </Grid>
            </Paper>


            <Paper>
                <IPGrid searchParams={searchParams}
                    refresh={refresh}
                    header={() => <ProtocolHeader></ProtocolHeader>}
                    row={(item) => <ProtocolRow item={item} deleteFunc={Delete}></ProtocolRow>}>

                </IPGrid>
            </Paper>

        </div>
    );
}


export default ProtocolSearch;